import AddressForm from "@/components/Common/forms/AddressForm";
import {PhoneInput} from "@/components/ui/PhoneInput";
import RegistrationInputField from "@/pages/registerCompany/RegistrationInputField";
import useRegistrationStore from "@/store/registration";
import {type FC} from "react";
import {useTranslation} from "react-i18next";

const CompanyDetailsStep: FC = () => {
  const {t} = useTranslation("common");
  const setValue = useRegistrationStore(state => state.setValue);
  const phoneNumber = useRegistrationStore(state => state.phoneNumber);
  const phoneNumberError = useRegistrationStore(state => state.errors.phoneNumber);
  const form = useRegistrationStore(state => state);
  const errors = useRegistrationStore(state => state.errors);
  const validateAddress = useRegistrationStore(state => state.validateAddress);

  return (
    <div className="flex w-full flex-col gap-5">
      <AddressForm
        className="gap-1"
        cityKey="addressCity"
        countryKey="country"
        errors={errors}
        inputClassName="border-neutral-grey-light"
        placeDescriptionKey="placeDescription"
        placeIdKey="placeId"
        postalKey="addressPostal"
        storeForm={form}
        storeSetter={setValue}
        streetKey="addressStreet"
        validateForm={validateAddress}
      />
      <PhoneInput
        id="registration-phone-number-field"
        dataTestId="registration-phone-number-field"
        value={phoneNumber ?? ""}
        onChange={value => setValue("phoneNumber", value)}
        defaultCountry="CH"
        error={phoneNumberError}
      />
      <RegistrationInputField
        storeKey="companyWebsite"
        label={t("companyWebsite")}
        placeholder="https://refluenced.com/"
      />
    </div>
  );
};

export default CompanyDetailsStep;
